import { Pipe, PipeTransform } from '@angular/core';

import { ENCLOSURE_OPTIMAL_CAPACITY } from '../../enclosure/models/enclosure.constants';

@Pipe({
    name: 'isProgressAboveLimit',
    standalone: false
})
export class IsProgressAboveLimitPipe implements PipeTransform {

  transform(progressValue: number, limit: number): boolean {
    if(!progressValue) {
      return false;
    }
    if(!limit) {
      limit = ENCLOSURE_OPTIMAL_CAPACITY;
    }
    return progressValue >= limit;
  }

}
